import React, { useEffect, useState } from 'react';
import { Box, Button, CircularProgress, Divider, FormControl, Grid, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material';
import Filters from '../../../components/Filters.js';
import Pagination from '../../../../dsasComponents/pagination/Pagination.js';
import { useLocation, useNavigate } from 'react-router-dom';
import useStyles from '../../../../styles/global-mui.js';
import { checkExistingCompetition, fetchCompetitions } from '../../../../api/index.js';
import CompetitionCard from './CompetitionCard.js';
import { getUserProvider } from '../../../../actions/auth.js';
import { discipline_all } from '../../../../bdd/bddSTUB.js';
import CompetitionCheckModal from '../create/CompetitionCheckModal.js';
import SelectGroupProvider from '../../../../dsasComponents/SelectGroupProvider.js';
import { Can } from '../../../../permissions/Can.js';
import { PERMISSIONS } from '../../../../permissions/permissionKeys.js';
import DsasButton from '../../../components/DsasButton/DsasButton.js';
import { faPlus, faTrophy } from '@fortawesome/free-solid-svg-icons';
import { usePermissions } from '../../../../permissions/usePermissions.js';

const initialCompetition = {
  name : "",
  discipline : "",
  provider : getUserProvider()
}
const GetCompetitions = () => {

  const navigate = useNavigate(); // Utilisation du hook useNavigate pour la redirection
  const location = useLocation();


  const [competitions, setCompetitions] = useState();
  const [loading, setLoading] = useState(false);

  const [competitionData, setCompetitionData] = useState(initialCompetition)
  const [existingCompetitions, setExistingCompetitions] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCheckComplete, setIsCheckComplete] = useState(false); // Gérer l'étape de vérification

  const { getPermission } = usePermissions();
  const providerPermission = getPermission(PERMISSIONS.FILTER_PROVIDER);



   // Configuration des filtres utilisés par la page GetPlayers
  let filtersConfig = [
  { key: 'provider', name: 'provider', fullAccess:providerPermission },
  { key: 'discipline', name: 'discipline' },
  { key: 'season', name: 'season' },
  
];

// if (providerPermission?.allowed)  { 
//   // Si la permission pour le filtre 'provider' est autorisée, on l'ajoute - avec fullAccess:true car on veut qu'il contienne tout les providers en liste
//   filtersConfig = [
//     ...filtersConfig, 
//     { key: 'provider', name: 'provider', fullAccess:true }
//   ];
// }
// const filtersConfig = filtersConfigRaw.filter(filter => {
//   if (!filter.permissionKey) return true; // Pas de permission requise : on garde
//   const permission = getPermission(filter.permissionKey);
//   return permission?.allowed; // On garde si la permission est autorisée
// });
  

  // // Configuration des filtres utilisés par la page GetPlayers
  // const filtersConfig = [
  //   { key: 'provider', name: 'provider', permissionKey : PERMISSIONS.FILTER_PROVIDER }, // Le filtre 'provider' sera utilisé avec la clé 'provider'
  //   { key: 'discipline', name: 'discipline' }, // Le filtre 'discipline'
  //   { key: 'season', name: 'season' }, // Le filtre 'season'
  // ];

  const searchParams = new URLSearchParams(location.search);
  const searchMode = searchParams.get('searchMode') || 'filters';

  // Synchronize URL parameters with state
  useEffect(() => {
    if (searchMode === 'filters') {
      // Reset state for simple search
      setCompetitionData(initialCompetition);
    }

    setCompetitions(undefined)
  }, [searchMode]);

  useEffect(() => {
      if (searchMode === 'simple') {
        // Populate state from URL parameters
        const name = searchParams.get('name') || '';
        const discipline = searchParams.get('discipline') || '';
        const provider = searchParams.get('provider') || getUserProvider();
        setCompetitionData({ name, discipline, provider });
      }
    }, [location.search, searchMode]);

  useEffect(() => {
    if(!isValidCheckExistingCompetition())
      return
    
        handleCheckExistingCompetition()
  }, [competitionData])

  // Gestion de l'application des filtres
  const handleApplyFilters = async (filters) => {
    setLoading(true);
    try {
      const response = await fetchCompetitions(filters); // Appel à l'API avec les filtres appliqués
      setCompetitions(response.data);
    } catch (error) {
      console.error('Failed to fetch competitions:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCompetitionData((prev) => ({ ...prev, [name]: value }));

    // Update URL with the new parameter
    const params = new URLSearchParams(location.search);
    params.set(name, value);
    navigate(`?${params.toString()}`, { replace: true });
  };

  const handleCheckExistingCompetition = async () => {

    setCompetitions([])

    if(!isValidCheckExistingCompetition())
      return

    const { name, discipline } = competitionData;
    const results = await checkExistingCompetition({ name, discipline });

    const similarCompetitions = results.data

    if(!similarCompetitions.length){
      setIsCheckComplete(true);
      setIsModalOpen(false);
    }else{

      const sameProviderCompetitions = similarCompetitions.filter(p => p.provider === competitionData.provider)

      const otherProviderCompetitions = similarCompetitions.filter(p => p.provider !== competitionData.provider)

      if(sameProviderCompetitions.length){
        setCompetitions(sameProviderCompetitions)
      } else if(otherProviderCompetitions.length){
        setExistingCompetitions(otherProviderCompetitions);
        setIsModalOpen(true);
      }
    }
  }

  const handleSearchModeChange = (mode) => {
    const params = new URLSearchParams();
    params.set('searchMode', mode);
    navigate(`?${params.toString()}`);

    setCompetitions([])
  };

  const isValidCheckExistingCompetition = () => {
    return competitionData.name && competitionData.discipline
  }

  const handleSelectOtherCompetition = (competition) => {

    const copyCompetition = {
      name : competition.name, 
      discipline : competition.discipline,
  
      enableAPI : competition.enableAPI, 
      particularGoalAverage : competition.particularGoalAverage, 
      nbDays : competition.nbDays, 
      nbTeamFinalPhase : competition.nbTeamFinalPhase,
      season : competition.season, 

      thirdPartyId: competition.thirdPartyId,
      thirdPartyEntityId: competition.thirdPartyEntityId,
      provider : getUserProvider()
    }

    navigate(`/sports/competitions/create`, { state: { copyCompetition } }); // Naviguer avec les données de l'equipe
    
    setIsCheckComplete(true); // L'utilisateur a passé la vérification
    setIsModalOpen(false);
  }

  const handleConfirmNone = () => {
    setIsCheckComplete(true); // Marquer que l'utilisateur a bien vérifié
    setIsModalOpen(false);

    navigate(`/sports/competitions/create`, { state: { copyCompetition : competitionData } }); // Naviguer avec les données de l'equipe
  };

  const handleCreateClick = () => {
    navigate(`/sports/competitions/create`); // Redirection vers la page de creation
  };

  const removeCompetitionFromList = (id) => {
    setCompetitions(s => s.filter(c => c._id !== id))
  }

  const classes = useStyles();

  return (
    <Box>

      {/*PAGE TITLE*/}
      <Box className='centered-medium-wrapper'>
        <h1 className='page-title'>Gestion des compétitions</h1>
      </Box>
      <Box className='medium-separator'></Box>

      {/*CREATE PLAYER BUTTON*/}
      <Box className='centered-medium-wrapper'>
        <Can permission={PERMISSIONS.SPORT_COMPETITION_HOME_BUTTON_CREATE}>
          <DsasButton label="Créer une compétition" icon={faTrophy} onClick={handleCreateClick} variant = 'secondary' />
        </Can>
      </Box>
      <Box className='medium-separator'></Box>

      {/*SEARCH SECTION*/}
      <Box className='centered-medium-wrapper'>
        {/*SEARCH BY NAME BUTTON*/}
        <DsasButton label="Rechercher par nom" onClick={() => handleSearchModeChange('simple')} variant = 'primarysub' focused = {searchMode === 'simple'} />
        {/*SEARCH BY DISCIPLINE BUTTON*/}
        <DsasButton label="Rechercher par discipline" onClick={() => handleSearchModeChange('filters')} variant = 'primarysub' focused = {searchMode !== 'simple'} />
      </Box>

      <Box className='padding-wrapper'>
        {searchMode === 'simple' && (
          <>
          <Grid container spacing={1.5} sx={{alignItems : 'flex-start'}}>
              {providerPermission?.allowed && (
                <Grid item xs={12} sm={12} md>
                  <SelectGroupProvider
                    className={classes.customInput}
                    value={competitionData.provider} onChange={handleChange} />
                </Grid>
              ) }
              <Grid item xs={12} sm={12} md>
                {/* Nom */}
                <TextField 
                  className={classes.customInput}
                  name="name" 
                  label="Nom" 
                  error={!competitionData.name} 
                  fullWidth 
                  value={competitionData.name} onChange={handleChange} />
              </Grid>
              <Grid item xs={12} sm={12} md>
                {/* Discipline */}
                <FormControl className={classes.customInput} 
                fullWidth error={!competitionData.discipline}>
                  <InputLabel>Discipline</InputLabel>
                  <Select name="discipline" value={competitionData.discipline}   onChange={handleChange} label={"Discipline"}>
                      {discipline_all.map((discipline) => (
                      <MenuItem key={discipline._id} value={discipline._id}>
                          {discipline.name}
                      </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          <CompetitionCheckModal
            open={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            results={existingCompetitions}
            onSelectOtherCompetition={handleSelectOtherCompetition}
            onConfirmNone={handleConfirmNone}
            actualProvider={competitionData.provider}
            />
          </>
        )}

       { searchMode === 'filters' && (
          <>
            {/* Composant Filters mis à jour avec les nouveaux filtres */}
            <Filters filtersConfig={filtersConfig} onApplyFilters={handleApplyFilters} onReset={() => setCompetitions([])} className={classes.customInput}/>
          </>
        )}

      </Box>

      {loading ? (
        //Si loading
        <CircularProgress />
      ) : 
        //Après chargement,
        //Si pas de compétitions initialisées
        <>
        { !competitions &&
            // Si filtres non-saisis, afficher un message de saisie des filtres
            <Box className='left-medium-wrapper'>Veuillez saisir les filtres.</Box>
            }
        { competitions?.length === 0 && isValidCheckExistingCompetition() && 
            // Si pas de compétitions et que filtres saisis, afficher un message de non-résultats trouvés
            <Box className='left-medium-wrapper'>Aucune compétition trouvée.</Box> }
        {searchMode === 'simple' && isValidCheckExistingCompetition() &&
                <Can permission={PERMISSIONS.SPORT_COMPETITION_HOME_BUTTON_CREATE}>
                  <Box className='centered-medium-wrapper'>
                    <DsasButton 
                    label="Créer avec les données saisies" 
                    icon={faPlus} 
                    onClick={() => handleSelectOtherCompetition(competitionData)}
                    variant = 'secondary' />
                  </Box>
                </Can>
              }
          {competitions?.length > 0 && 
          // Si compétitions trouvées, afficher les résultats
          <Box className='padding-wrapper'>
            <Pagination items={competitions} type='Compétitions' className={classes.customTablePagination}>
              {competitions.map((competition, index) => (
                  <CompetitionCard competition={competition} 
                  removeCompetitionFromList={removeCompetitionFromList} 
                  className={classes.customCard} 
                  showExport={true}
                  showPicture={true}
                  />
              ))}
            </Pagination>
          </Box>
          }
        </>
      }
  </Box>
  );
};

export default GetCompetitions;
